var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "tooltip focus:outline-none",
      class: `${_vm.buttonClassName} ${
        _vm.disabled
          ? "text-gray-200 hover:text-gray-200"
          : "text-gray-500 hover:text-primary-500"
      }`,
      attrs: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("span", { staticClass: "mdi text-lg", class: _vm.buttonIcon }),
      _c(
        "span",
        {
          staticClass: "tooltiptext",
          class: _vm.disabled
            ? "text-gray-600 bg-gray-300"
            : "text-white bg-primary-500",
        },
        [_vm._v(_vm._s(_vm.buttonText))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }